import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Icon } from "@iconify/react/dist/iconify.js";

const ServiceCard = ({ imgUrl, title, description, id, path }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div
      className=" cursor-pointer p-[30px] bg-white rounded-lg border-slate-200 border shadow-sm flex flex-col    hover:-translate-y-3 hover:shadow-2xl transition-all duration-300"
      onClick={() => {
        // navigate("../" + path.common.SERVICES, { state: { targetId: id } });
        navigate(path);
      }}
    >
      <div className="rounded-full w-[70px] min-h-[70px] flex items-center justify-center bg-secondary1">
        <Icon icon={imgUrl} className="w-10 h-10 text-white" />
      </div>

      <div className="flex flex-col justify-between h-full ">
        <h3 className="text-[18px]  xl:text-[1rem] qhd:text-[1rem] text-primary font-medium pt-[24px] line-clamp-1">
          {t(title)}
        </h3>

        <div className="flex flex-col justify-between h-full">
          <p className="text-primary qhd:text-[1rem] leading-relaxed line-clamp-3 pt-[8px] mb-[8px] text-justify">
            {t(description)}
          </p>
        </div>
        <div className="flex items-center text-[1rem] gap-2 hover:text-secondary1 text-primary cursor-pointer transition-colors">
          <span
            onClick={() => {
              // navigate("../" + path.common.SERVICES, {
              //   state: { targetId: id },
              // });

              navigate(path);
            }}
            className="qhd:text-[1rem]"
            style={{ fontWeight: 500 }}
          >
            {t("LearnMore")}
          </span>
          <span
            className="text-[1rem] qhd:text-[1rem] "
            style={{ fontWeight: 500 }}
          >
            →
          </span>
        </div>
      </div>
    </div>
  );
};
export default ServiceCard;
